import request from '@/utils/request'
import store from '@/store'

/**
 * 分类网站列表
 * @param {string} langCode 语言代码
 */
export function categorySiteList(langCode) {
  return request({
    url: '/client/nav/category/site/list',
    method: 'get',
    params: {
      langCode: langCode || store.state.app.language || 'zh'
    }
  })
}

/**
 * 分类列表
 * @param {string} langCode 语言代码
 */
export function categoryList(langCode) {
  return request({
    url: '/client/nav/category/list',
    method: 'get',
    params: {
      langCode: langCode || store.state.app.language || 'zh'
    }
  })
}

/**
 * 获取站点详情
 * @param {number} id 站点 ID
 */
export function getSiteDetail(id) {
  return request({
    url: `/nav/site/client/detail/${id}`,
    method: 'get',
    params: {
      langCode: store.state.app.language || 'zh'
    }
  })
}
